import script from "./AnalyticsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsView.vue?vue&type=script&setup=true&lang=js"

import "./AnalyticsView.vue?vue&type=style&index=0&id=080b42fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-080b42fb"]])

export default __exports__